<template>
  <el-dialog
    title="复合片入库"
    :visible.sync="visible"
    width="450px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item label="复合片" prop="commodity_id">
        <CommoditySelect
          :category="2"
          v-model="model.commodity_id"
        ></CommoditySelect>
        <!-- <el-select
          class="long"
          size="small"
          placeholder="请搜索或选择"
          filterable
          remote
          :remote-method="getPdcs"
          :loading="loading"
          v-model="model.pdc_id"
        >
          <el-option
            v-for="item in pdcs"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="新 / 旧" prop="category">
        <el-select v-model="model.category" style="width: 100%">
          <el-option key="1" label="新齿" :value="1"></el-option>
          <el-option key="2" label="旧齿" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应方" prop="supplier">
        <el-input v-model="model.supplier"></el-input>
      </el-form-item>
      <el-form-item label="到货日期" prop="arrive_date">
        <el-date-picker
          v-model="model.arrive_date"
          type="date"
          placeholder="选择日期"
          style="width: 100%"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到货批次" prop="arrive_batch">
        <el-input v-model="model.arrive_batch"></el-input>
      </el-form-item>
      <el-form-item label="数量" prop="number">
        <el-input-number
          class="long"
          v-model="model.number"
          :min="1"
          :max="1000000"
        ></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="单价" prop="price">
        <el-input-number
          v-model="model.price"
          :precision="2"
          :step="0.5"
          :min="0"
          :max="100000"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="税率" prop="tax_rate">
        <el-input-number
          v-model="model.tax_rate"
          :precision="1"
          :step="0.1"
          :min="0"
          :max="100"
        ></el-input-number>
      </el-form-item> -->
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="model.remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { pdcInRecordNew, pdcInRecordUpdate, pdcList } from '@/service/getData'
import CommoditySelect from './select/commodity_select.vue'

export default {
  components: {
    CommoditySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      } else {
        if (this.model.id) {
          this.getPdcs(this.model.pdc.name)
        }
      }
    },
  },
  created() {},
  data() {
    return {
      visible: this.show,
      loading: false,
      pdcs: [],
      rules: {
        pdc_id: [{ required: true, message: '请选择复合片' }],
        arrive_batch: [{ required: true, message: '请填写到货批次' }],
      },
    }
  },
  methods: {
    async getPdcs(query) {
      if (query !== '') {
        this.loading = true
        let res = await pdcList({ query: query })
        if (res.status == 0) {
          this.pdcs = res.data.list
          this.loading = false
        }
      } else {
        this.pdcs = []
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await pdcInRecordUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await pdcInRecordNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 220px;
}
</style>